<div class="mat-elevation-z8">

    <!-- Users Tsble -->
    <table mat-table [dataSource]="dataSource" [ngClass]="{'opened': tableName === 'groups'}">


        <!-- Name Column -->
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>
                <mat-form-field>
                    <input matInput class="form-field" [formControl]="nameFilter"
                        placeholder="{{'businessTexts.name' | translate}}">
                </mat-form-field>
            </th>
            <td mat-cell *matCellDef="let element" [ngClass]="{'blocked': element.status === 'BLOCKED'}">
                <mat-checkbox color="primary" (change)="onCheckChange($event.checked, element)" [checked]="isChecked(element)"
                    *ngIf="tableName=='inGroupDialog'">
                </mat-checkbox>
                {{getName(element)}}
            </td>
        </ng-container>

        <!-- Role Column -->
        <ng-container matColumnDef="role">
            <th mat-header-cell *matHeaderCellDef> {{'businessTexts.role' | translate}} </th>
            <td mat-cell *matCellDef="let element" [ngClass]="{'blocked': element.status === 'BLOCKED'}">
                {{getRole(element.role)}} </td>
        </ng-container>

        <!-- Position Column -->
        <ng-container matColumnDef="position">
            <th mat-header-cell *matHeaderCellDef>
                <mat-form-field>
                    <input matInput class="form-field" [formControl]="positionFilter"
                        placeholder="{{'businessTexts.position' | translate}}">
                </mat-form-field>
            </th>
            <td mat-cell *matCellDef="let element" [ngClass]="{'blocked': element.status === UserStatus.BLOCKED}">
                {{element.position}} </td>
        </ng-container>

        <!-- Email Column -->
        <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef>
                <mat-form-field>
                    <input matInput class="form-field" [formControl]="emailFilter"
                        placeholder="{{'businessTexts.email' | translate}}">
                </mat-form-field>
            </th>
            <td mat-cell *matCellDef="let element" [ngClass]="{'blocked': element.status === UserStatus.BLOCKED}">
                {{element.email}} </td>
        </ng-container>

        <!-- Phone Column -->
        <ng-container matColumnDef="phone">
            <th mat-header-cell *matHeaderCellDef> {{'businessTexts.phone' | translate}} </th>
            <td mat-cell *matCellDef="let element" [ngClass]="{'blocked': element.status === UserStatus.BLOCKED}">
                {{element.phoneNumber}} </td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef> {{'businessTexts.actions' | translate}} </th>
            <td mat-cell *matCellDef="let element" [ngClass]="{'blocked': element.status === UserStatus.BLOCKED}">
                <button mat-icon-button matTooltip="{{'businessTexts.edit' | translate}}" *ngIf="tableName=='main'"
                    (click)="onEditUser(element)">
                    <cqes-icon icon="edit"></cqes-icon>
                </button>
                <button mat-icon-button matTooltip="{{'businessTexts.block' | translate}}"
                    *ngIf="tableName=='main' && element.status==UserStatus.ACTIVE" (click)="onBlockUser(element)">
                    <cqes-icon icon="person"></cqes-icon>
                </button>
                <button mat-icon-button matTooltip="{{'businessTexts.unblock' | translate}}"
                    *ngIf="tableName=='main' && element.status==UserStatus.BLOCKED" (click)="onUnblockUser(element)">
                    <cqes-icon icon="person"></cqes-icon>
                    <div class="second">
                        \
                    </div>
                </button>
                <button mat-icon-button matTooltip="{{'businessTexts.delete' | translate}}" *ngIf="tableName=='main'"
                    (click)="onDeleteUser(element)">
                    <cqes-icon icon="delete"></cqes-icon>
                </button>
                <button mat-icon-button matTooltip="{{'businessTexts.remove' | translate}}" *ngIf="tableName=='groups'"
                    (click)="removeFromGroup(element)">
                    <div class="vertical-align">
                        <div class="minus">
                            -
                        </div>
                        <cqes-icon icon="person"></cqes-icon>
                    </div>
                </button>
            </td>
        </ng-container>


        <!-- Header top -->
        <ng-container matColumnDef="header-top">
            <th mat-header-cell *matHeaderCellDef class="header" [style.text-align]="center"
                [attr.colspan]="getColumnCount()">
                <div class="wrap">
                    <div class="label" [ngClass]="{'main-header-center': tableName!='inGroupDialog'}">
                        {{'businessTexts.users' | translate}}
                    </div>
                    <div class="add-icon" *ngIf="tableName!='inGroupDialog'">
                        <button mat-icon-button matTooltip="{{'businessTexts.add' | translate}}" (click)="addUser()">
                            <cqes-icon icon="person_add" class="add"></cqes-icon>
                        </button>
                    </div>
                </div>
            </th>
        </ng-container>


        <ng-container *ngIf="tableName=='main' || tableName=='inGroupDialog'">
            <tr mat-header-row *matHeaderRowDef="['header-top']" class="main-header"></tr>
        </ng-container>


        <tr mat-header-row *matHeaderRowDef="usersColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: usersColumns;"></tr>
    </table>


    <mat-paginator [pageSize]="tableName=='inGroupDialog' ? pageDialogSize: tableHelper.pageSize" [pageSizeOptions]="tableName=='inGroupDialog' ? pageDialogOptions : tableHelper.pageSizeOptions"
        [ngClass]="{'opened': tableName === 'groups'}">
    </mat-paginator>

</div>